// Public: Status.io embedded widget script source
export const scriptSrc = `https://${process.env.VUE_APP_STATUS_PAGE}.statuspage.io/embed/script.js`
